// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useLocation } from 'react-router-dom';
// import { FiFolder, FiX, FiDownload, FiTrash2, FiFile, FiEye } from 'react-icons/fi';
// import { InputAdornment, TextField } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import { useRef } from 'react';

// const LibrarySection = () => {
//   const staticDocuments = [
//     // Your existing document list here (same as before)
//     { id: '1', title: 'Factory Assessment Reports' },
//     { id: '2', title: 'Supplier NCR (After Assessment) closure reports' },
//     { id: '3', title: 'QAP' },
//     { id: '4', title: 'Deviations approvals' },
//     { id: '5', title: 'Supplier 8Ds' },
//     { id: '6', title: 'Invoice wise Warranty certificates' },
//     { id: '7', title: 'Third party lab test reports' },
//     { id: '8', title: 'Raw material reliability reports' },
//     { id: '9', title: 'Supplier Calibrations reports' },
//     { id: '10', title: 'Packaging work instructions' },
//     { id: '11', title: 'Golden and silver modules certificate' },
//     { id: '12', title: 'ISO 9001 certificate' },
//     { id: '13', title: 'ISO 18001 certificate' },
//     { id: '14', title: 'Thermography reports' },
//     { id: '15', title: 'Warranty Certificates' },
//     { id: '16', title: 'Site EL Inspection reports' },
//     { id: '17', title: 'Site Flash testing reports' },
//     { id: '18', title: 'Work Instruction' },
//     { id: '19', title: 'Checklist/ Forms' },    
//     { id: '20', title: 'Any Other Reports' },
//   ];

//   const [documents, setDocuments] = useState([]);
//   const [filteredDocuments, setFilteredDocuments] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   const location = useLocation();
//   const department = location.pathname.split('/').filter(Boolean).pop() || '';
//   const projectId = localStorage.getItem('selectedProject');

//   // Ref for scrolling to matched file in modal
//   const fileRefs = useRef({});

//   // Fetch documents on mount
//   useEffect(() => {
//     const fetchDocuments = async () => {
//       if (!projectId || !department) {
//         setLoading(false);
//         setError('projectId and department are required to fetch documents.');
//         return;
//       }
//       try {
//         setLoading(true);
//         setError(null);
//         const response = await apiClient.get(`get_documents`, {
//           params: { projectId, department },
//         });
//         const backendDocs = response.data.documents || [];
//         const mergedDocs = staticDocuments.map(staticDoc => {
//           const matchedDoc = backendDocs.find(doc => doc.title === staticDoc.title);
//           return {
//             ...staticDoc,
//             files: matchedDoc?.files || [],
//           };
//         });
//         setDocuments(mergedDocs);
//         setFilteredDocuments(mergedDocs);
//       } catch (err) {
//         setError('Failed to fetch documents. Please try again later.');
//         console.error('Error fetching documents:', err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchDocuments();
//   }, [projectId, department]);

//   const handleCardClick = (document) => {
//     setSelectedDocument(document);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedDocument(null);
//   };

//   const handleDeleteFile = async (fileId) => {
//     const remark = prompt('Please provide a remark for deleting this file:');
//     if (!remark || remark.trim() === '') {
//       alert('Remark is required to delete the file.');
//       return;
//     }
//     const documentId = fileId.split('_')[0];
//     try {
//       const response = await axios.delete(`${baseURL}delete_document`, {
//         params: { documentId, fileId, remark: remark.trim() },
//       });
//       setDocuments((prevDocuments) =>
//         prevDocuments.map((doc) =>
//           doc.id === selectedDocument.id
//             ? {
//                 ...doc,
//                 files: doc.files.filter((file) => file.id !== fileId),
//               }
//             : doc
//         )
//       );
//       alert(response.data.message || 'File deleted successfully.');
//       window.location.reload();
//     } catch (err) {
//       const errorMessage = err.response?.data?.error || 'Failed to delete file. Please try again.';
//       alert(errorMessage);
//       console.error('Error deleting file:', err);
//     }
//   };

//   const handleSearch = (e) => {
//     const query = e.target.value.toLowerCase();
//     setSearchQuery(query);

//     const filtered = documents.map((doc) => {
//       const titleMatch = doc.title.toLowerCase().includes(query);

//       const updatedFiles = doc.files.map(file => ({
//         ...file,
//         isMatched: file.name.toLowerCase().includes(query),
//       }));

//       const hasMatchedFile = updatedFiles.some(f => f.isMatched);

//       setTimeout(() => {
//         if (hasMatchedFile && openModal && doc.id === selectedDocument.id) {
//           const firstMatched = updatedFiles.find(f => f.isMatched);
//           if (firstMatched && fileRefs.current[firstMatched.id]) {
//             fileRefs.current[firstMatched.id].scrollIntoView({
//               behavior: 'smooth',
//               block: 'center',
//             });
//           }
//         }
//       }, 100);

//       return {
//         ...doc,
//         files: updatedFiles,
//         isVisible: titleMatch || hasMatchedFile,
//       };
//     });

//     setFilteredDocuments(filtered.filter(doc => doc.isVisible));
//   };

//   return (
//     <div className="p-6">
//       <h1 className="text-2xl font-bold text-center mb-6">LIBRARY</h1>

//       {error && <p className="text-center text-red-600 mb-4">{error}</p>}

//       {/* Search Bar */}
//       <div className="mb-6">
//         <TextField
//           type="text"
//           placeholder="Search documents..."
//           value={searchQuery}
//           onChange={handleSearch}
//           fullWidth
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             '& .MuiOutlinedInput-root': {
//               borderRadius: '8px',
//               backgroundColor: '#fff',
//               border: '1px solid #d1d5db',
//               '&:hover': {
//                 borderColor: '#9ca3af',
//               },
//             },
//           }}
//         />
//       </div>

//       {loading ? (
//         <div className="flex justify-center mb-6">
//           <div className="w-8 h-8 border-4 border-t-transparent border-gray-600 rounded-full animate-spin"></div>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//           {filteredDocuments.length > 0 ? (
//             filteredDocuments.map((document) => (
//               <div
//                 key={document.id}
//                 className="p-4 h-40 flex flex-col justify-between bg-white rounded-lg shadow-md cursor-pointer transform transition-transform hover:scale-105"
//                 onClick={() => handleCardClick(document)}
//               >
//                 <div>
//                   <h2 className="text-lg">{document.title}</h2>
//                   <p className="text-sm text-gray-500">{document.files.length} file(s)</p>
//                 </div>
//                 <div className="text-right">
//                   <button className="px-3 py-1 text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 rounded-md">
//                     View Files
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p className="text-center col-span-full">No documents found.</p>
//           )}
//         </div>
//       )}

//       {/* Modal for File Preview */}
//       {openModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1300]">
//           <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-h-[90vh] overflow-y-auto relative">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xl">{selectedDocument?.title}</h2>
//               <button onClick={handleCloseModal} className="text-gray-500 hover:text-gray-700">
//                 <FiX size={24} />
//               </button>
//             </div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
//               {selectedDocument?.files
//                 .filter(file => file.isMatched !== false)
//                 .map((file) => (
//                   <div
//                     key={file.id}
//                     ref={(el) => (fileRefs.current[file.id] = el)}
//                     className="p-4 flex flex-col justify-between bg-white rounded-lg shadow-md"
//                   >
//                     {/* Thumbnail or Icon */}
//                     {file.url && (file.url.includes('.jpg') || file.url.includes('.png')) ? (
//                       <img
//                         src={file.url}
//                         alt={file.name}
//                         className="w-full h-24 object-cover rounded-md"
//                       />
//                     ) : (
//                       <FiFile className="text-5xl mx-auto my-4 text-gray-500" />
//                     )}
//                     <div>
//                       <p className="text-sm truncate">{file.name}</p>
//                       <p className="text-xs text-gray-500">
//                         Uploaded: {new Date(file.uploadDate).toLocaleDateString()}
//                       </p>
//                       <p className="text-xs text-gray-500">
//                         Remark: {file.remark || 'N/A'}
//                       </p>
//                       {file.customDocumentType && (
//                         <p className="text-xs text-gray-500">
//                           Custom Type: {file.customDocumentType}
//                         </p>
//                       )}
//                     </div>
//                     <div className="flex justify-between mt-2">
//                       <button
//                         onClick={() => window.open(file.url, '_blank')}
//                         className="text-gray-600 hover:text-gray-800"
//                       >
//                         <FiEye size={20} />
//                       </button>
//                       <button
//                         onClick={() => handleDeleteFile(file.id)}
//                         className="text-red-600 hover:text-red-800"
//                       >
//                         <FiTrash2 size={20} />
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LibrarySection;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { FiFolder, FiX, FiDownload, FiTrash2, FiFile, FiEye } from 'react-icons/fi';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useRef } from 'react';
import apiClient from '../../../../pages/keycloak/axiosInstance';

const LibrarySection = () => {
  const staticDocuments = [
    { id: '1', title: 'Factory Assessment Reports' },
    { id: '2', title: 'Supplier NCR (After Assessment) closure reports' },
    { id: '3', title: 'QAP' },
    { id: '4', title: 'Deviations approvals' },
    { id: '5', title: 'Supplier 8Ds' },
    { id: '6', title: 'Invoice wise Warranty certificates' },
    { id: '7', title: 'Third party lab test reports' },
    { id: '8', title: 'Raw material reliability reports' },
    { id: '9', title: 'Supplier Calibrations reports' },
    { id: '10', title: 'Packaging work instructions' },
    { id: '11', title: 'Golden and silver modules certificate' },
    { id: '12', title: 'ISO 9001 certificate' },
    { id: '13', title: 'ISO 18001 certificate' },
    { id: '14', title: 'Thermography reports' },
    { id: '15', title: 'Warranty Certificates' },
    { id: '16', title: 'Site EL Inspection reports' },
    { id: '17', title: 'Site Flash testing reports' },
    { id: '18', title: 'Work Instruction' },
    { id: '19', title: 'Checklist/ Forms' },    
    { id: '20', title: 'Any Other Reports' },
  ];

  const [documents, setDocuments] = useState([]);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Role check: Delete icon only visible if user has SD_Quality_Delete
  const [canDelete, setCanDelete] = useState(false);

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const department = location.pathname.split('/').filter(Boolean).pop() || '';
  const projectId = localStorage.getItem('selectedProject');
  const fileRefs = useRef({});

  // Check user role on mount
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanDelete(roles.includes("SD_Quality_Delete"));
    }
  }, []);

  // Fetch documents
  useEffect(() => {
    const fetchDocuments = async () => {
      if (!projectId || !department) {
        setLoading(false);
        setError('projectId and department are required to fetch documents.');
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const response = await apiClient.get(`get_documents`, {
          params: { projectId, department },
        });
        const backendDocs = response.data.documents || [];
        const mergedDocs = staticDocuments.map(staticDoc => {
          const matchedDoc = backendDocs.find(doc => doc.title === staticDoc.title);
          return {
            ...staticDoc,
            files: matchedDoc?.files || [],
          };
        });
        setDocuments(mergedDocs);
        setFilteredDocuments(mergedDocs);
      } catch (err) {
        setError('Failed to fetch documents. Please try again later.');
        console.error('Error fetching documents:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDocuments();
  }, [projectId, department]);

  const handleCardClick = (document) => {
    setSelectedDocument(document);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedDocument(null);
  };

  const handleDeleteFile = async (fileId) => {
    const remark = prompt('Please provide a remark for deleting this file:');
    if (!remark || remark.trim() === '') {
      alert('Remark is required to delete the file.');
      return;
    }
    const documentId = fileId.split('_')[0];
    try {
      const response = await apiClient.delete(`delete_document`, {
        params: { documentId, fileId, remark: remark.trim() },
      });
      setDocuments((prevDocuments) =>
        prevDocuments.map((doc) =>
          doc.id === selectedDocument.id
            ? {
                ...doc,
                files: doc.files.filter((file) => file.id !== fileId),
              }
            : doc
        )
      );
      alert(response.data.message || 'File deleted successfully.');
      window.location.reload();
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Failed to delete file. Please try again.';
      alert(errorMessage);
      console.error('Error deleting file:', err);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = documents.map((doc) => {
      const titleMatch = doc.title.toLowerCase().includes(query);

      const updatedFiles = doc.files.map(file => ({
        ...file,
        isMatched: file.name.toLowerCase().includes(query),
      }));

      const hasMatchedFile = updatedFiles.some(f => f.isMatched);

      setTimeout(() => {
        if (hasMatchedFile && openModal && doc.id === selectedDocument.id) {
          const firstMatched = updatedFiles.find(f => f.isMatched);
          if (firstMatched && fileRefs.current[firstMatched.id]) {
            fileRefs.current[firstMatched.id].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }
      }, 100);

      return {
        ...doc,
        files: updatedFiles,
        isVisible: titleMatch || hasMatchedFile,
      };
    });

    setFilteredDocuments(filtered.filter(doc => doc.isVisible));
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-center mb-6">LIBRARY</h1>

      {error && <p className="text-center text-red-600 mb-4">{error}</p>}

      {/* Search Bar */}
      <div className="mb-6">
        <TextField
          type="text"
          placeholder="Search documents..."
          value={searchQuery}
          onChange={handleSearch}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              backgroundColor: '#fff',
              border: '1px solid #d1d5db',
              '&:hover': {
                borderColor: '#9ca3af',
              },
            },
          }}
        />
      </div>

      {loading ? (
        <div className="flex justify-center mb-6">
          <div className="w-8 h-8 border-4 border-t-transparent border-gray-600 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filteredDocuments.length > 0 ? (
            filteredDocuments.map((document) => (
              <div
                key={document.id}
                className="p-4 h-40 flex flex-col justify-between bg-white rounded-lg shadow-md cursor-pointer transform transition-transform hover:scale-105"
                onClick={() => handleCardClick(document)}
              >
                <div>
                  <h2 className="text-lg">{document.title}</h2>
                  <p className="text-sm text-gray-500">{document.files.length} file(s)</p>
                </div>
                <div className="text-right">
                  <button className="px-3 py-1 text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 rounded-md">
                    View Files
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center col-span-full">No documents found.</p>
          )}
        </div>
      )}

      {/* File Preview Modal */}
      {openModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1300]">
          <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-h-[90vh] overflow-y-auto relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl">{selectedDocument?.title}</h2>
              <button onClick={handleCloseModal} className="text-gray-500 hover:text-gray-700">
                <FiX size={24} />
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              {selectedDocument?.files
                .filter(file => file.isMatched !== false)
                .map((file) => (
                  <div
                    key={file.id}
                    ref={(el) => (fileRefs.current[file.id] = el)}
                    className="p-4 flex flex-col justify-between bg-white rounded-lg shadow-md"
                  >
                    {/* Thumbnail or Icon */}
                    {file.url && (file.url.includes('.jpg') || file.url.includes('.png') || file.url.includes('.jpeg')) ? (
                      <img
                        src={file.url}
                        alt={file.name}
                        className="w-full h-24 object-cover rounded-md"
                      />
                    ) : (
                      <FiFile className="text-5xl mx-auto my-4 text-gray-500" />
                    )}

                    <div>
                      <p className="text-sm truncate">{file.name}</p>
                      <p className="text-xs text-gray-500">
                        Uploaded: {new Date(file.uploadDate).toLocaleDateString()}
                      </p>
                      <p className="text-xs text-gray-500">
                        Remark: {file.remark || 'N/A'}
                      </p>
                      {file.customDocumentType && (
                        <p className="text-xs text-gray-500">
                          Custom Type: {file.customDocumentType}
                        </p>
                      )}
                    </div>

                    <div className="flex justify-between mt-2">
                      {/* View File */}
                      <button
                        onClick={() => window.open(file.url, '_blank')}
                        className="text-gray-600 hover:text-gray-800"
                      >
                        <FiEye size={20} />
                      </button>

                      {/* Delete Icon - Only visible if user has SD_Quality_Delete */}
                      {canDelete && (
                        <button
                          onClick={() => handleDeleteFile(file.id)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <FiTrash2 size={20} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LibrarySection;